import { render, staticRenderFns } from "./RenderExclamation.vue?vue&type=template&id=71cf530c"
import script from "./RenderExclamation.vue?vue&type=script&lang=ts"
export * from "./RenderExclamation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports